import { render, staticRenderFns } from "./WorkingHoursInputB.vue?vue&type=template&id=8097169a"
import script from "./WorkingHoursInputB.vue?vue&type=script&lang=js"
export * from "./WorkingHoursInputB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports